export default {"src":"https://images-cdn.curipod.com/d-a1411b0a/_next/static/media/loaderstars.62e39e18.svg","height":669,"width":679};